<template>
  <b-row class="gg">
    <b-col>
      <b-card>
        <b-card-body style="padding:0 0 40px 0">
          <div class="certificate-list">
            <DxLoadPanel
              :position="position"
              :visible.sync="loading"
              :show-indicator="showIndicator"
              :show-pane="showPane"
              :shading="shading"
              :close-on-outside-click="closeOnOutsideClick"
              shading-color="rgba(0,0,0,0.4)"
            />
            <DxDataGrid
              :style="{height:heightAuto}"
              class="mt-1"
              id="gridContainer"
              :customize-columns="customizeColumns"
              :data-source="itemsForWhGrid"
              :show-borders="true"
              @content-ready="onContentReady"
              :show-column-lines="true"
              :show-row-lines="true"
              :row-alternation-enabled="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :column-auto-width="true"
            >
              <DxColumnChooser :enabled="true" mode="select" />
              <DxExport :enabled="true" file-name="Report" />
              <DxFilterRow :visible="true" />
              <DxSearchPanel :visible="true" :width="240" :placeholder="$t('certificate.search')" />
              <DxColumn :caption="$t('sale.products')" data-field="product">
				  <DxColumn :caption="$t('goods.name')" data-field="name" width="180" />
				  <DxColumn :caption="$t('goods.special-barcode')" data-field="barcode" />
				  <DxColumn :caption="$t('goods.artikul')" data-field="artikul" />
				  <DxColumn :caption="isShop ? $t('client.create.customer') : 'Подкатегория 1'" data-field="subName" />
				  <DxColumn :caption="isShop ? $t('goods.category') : 'Подкатегория 2'" data-field="sub2Name" />
				  <DxColumn :caption="isShop ? $t('goods.subcategory') : 'Подкатегория 3'" data-field="sub3Name" />
				  <DxColumn :visible="false" :caption="$t('goods.brand')" data-field="brandName" />
				  <DxColumn :visible="false" :caption="$t('goods.color')" data-field="color" />
				  <DxColumn :visible="false" :caption="$t('goods.gender')" data-field="genderName" />
              </DxColumn>

              <DxColumn :caption="depNames">
                <!-- COUNT -->
                <DxColumn :caption="$t('sale.kol-vo')" data-field="inventory" data-type="number" class="text-center" />
                <!-- COUNT END -->

                <!-- INCOME_PRICE GROUP COLUMN -->
<!--                <DxColumn v-if="isAdmin" :caption="$t('warehouse.table.tableIncome')">-->
<!--                  <DxColumn-->
<!--                    :caption="$t('warehouse.table.incomeUzs')"-->
<!--                    :calculate-cell-value="incomePriceForRow"-->
<!--                    data-field="incomePriceUzs"-->
<!--                    data-type="number"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                  <DxColumn-->
<!--                    :caption="$t('warehouse.table.totalIncomeUzs')"-->
<!--                    data-field="totalIncomePrice"-->
<!--                    :calculate-cell-value="totalIncomePriceForRow"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                </DxColumn>-->
                <!-- INCOME_PRICE GROUP COLUMN END -->

                <!-- WHOLE_PRICE GROUP COLUMN -->
<!--                <DxColumn :caption="$t('warehouse.table.tableWholesale')">-->
<!--                  <DxColumn-->
<!--                    data-type="number"-->
<!--                    :caption="$t('warehouse.table.priceWholesale')"-->
<!--                    :calculate-cell-value="wholePriceForRow"-->
<!--                    data-field="priceWholesale"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                  <DxColumn-->
<!--                    :caption="$t('warehouse.table.totalPriceWholesale')"-->
<!--                    data-field="totalWholePrice"-->
<!--                    :calculate-cell-value="totalWholePriceForRow"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                </DxColumn>-->
                <!-- WHOLE_PRICE GROUP COLUMN END -->

                <!-- RETAIL_PRICE GROUP COLUMN -->
<!--                <DxColumn :caption="$t('warehouse.table.tableRetail')">-->
<!--                  <DxColumn-->
<!--                    :caption="$t('warehouse.table.priceUzs')"-->
<!--                    :calculate-cell-value="retailPriceForRow"-->
<!--                    data-field="priceUzs"-->
<!--                    data-type="number"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                  <DxColumn-->
<!--                    :caption="$t('warehouse.table.totalPriceUzs')"-->
<!--                    data-field="totalRetailPrice"-->
<!--                    :calculate-cell-value="totalRetailPriceForRow"-->
<!--                    :format="priceFormat"-->
<!--                  />-->
<!--                </DxColumn>-->
                <!-- RETAIL_PRICE GROUP COLUMN END -->
              </DxColumn>
              <DxScrolling mode="virtual" />
              <DxSorting mode="single" />
              <DxSummary :calculate-custom-summary="calculateSelectedRow">
                <DxTotalItem
                  name="totalCountForFooter"
                  summary-type="custom"
                  display-format="{0}"
                  show-in-column="inventory"
                />

                <DxTotalItem
                  name="totalIncomePriceForFooter"
                  summary-type="custom"
                  display-format="{0}"
                  show-in-column="totalIncomePrice"
                  :valueFormat="{minimumFractionDigits: 2}"
                />

                <DxTotalItem
                  name="totalWholePriceForFooter"
                  summary-type="custom"
                  display-format="{0}"
                  show-in-column="totalWholePrice"
                  :valueFormat="{minimumFractionDigits: 2}"
                />

                <DxTotalItem
                  name="totalRetailPriceForFooter"
                  summary-type="custom"
                  display-format="{0}"
                  show-in-column="totalRetailPrice"
                  :valueFormat="{minimumFractionDigits: 2}"
                />
              </DxSummary>
            </DxDataGrid>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxExport,
  DxSummary,
  DxTotalItem,
  DxSorting,
  DxSearchPanel,
  DxHeaderFilter,
  DxFilterRow,
  DxColumnChooser
} from "devextreme-vue/data-grid";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import Multiselect from "vue-multiselect";
import { mapGetters, mapState } from "vuex";
import {TokenService} from "../../../../services/storage.service"
export default {
  name: "ItemsListGrid",
  components: {
    Multiselect,
    DxDataGrid,
    DxScrolling,
    DxSorting,
    DxLoadPanel,
    DxSummary,
    DxColumnChooser,
    DxTotalItem,
    DxHeaderFilter,
    DxSearchPanel,
    DxExport,
    DxFilterRow,
    DxColumn
  },
  props: {
    selectedDeps: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  data() {
    return {
      priceFormat: {
        type: "fixedPoint",
        precision: 2
      },
      position: { of: "#gridContainer" },
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      gdpFormat: {
        type: "percent",
        precision: 1
      },
      lastDate: null,
      start: null,
      end: null,
      searchQuery: "",
      series: [],
      chartOptions: {},
      filter: {
        departmentId: [],
        start: null,
        end: null,
        total: null,
        page: 1,
        limit: 20
      },
      depCurrencyCode: null,
      departmentView: false,
      whDocList: [],
      whItemsByDate: [],
      emptyTable: true,
      emptyTable2: true,
      loadingLocal: false,
      extraCostModalItems: [],
      WhDocModalItems: [],
      currentDepName: ""
    };
  },
  methods: {
    incomePriceForRow(data) {
      let returnPrice = 0;
      let pricesArray = [];
      try {
        pricesArray = JSON.parse(data.incomeUzs);
      } catch (error) {
        pricesArray = [];
      }
      if (pricesArray) {
        if (pricesArray.length > 0) {
          pricesArray.forEach(price => {
            if (price && price > 0) {
              returnPrice = price;
            }
          });
        }
      }
      return returnPrice;
    },
    wholePriceForRow(data) {
      let returnPrice = 0;
      let pricesArray = [];
      try {
        pricesArray = JSON.parse(data.priceWholesale);
      } catch (error) {
        pricesArray = [];
      }
      if (pricesArray) {
        if (pricesArray.length > 0) {
          pricesArray.forEach(price => {
            if (price && price > 0) {
              returnPrice = price;
            }
          });
        }
      }
      return returnPrice;
    },
    retailPriceForRow(data) {
      let returnPrice = 0;
      let pricesArray = [];
      try {
        pricesArray = JSON.parse(data.priceUzs);
      } catch (error) {
        pricesArray = [];
      }
      if (pricesArray) {
        if (pricesArray.length > 0) {
          pricesArray.forEach(price => {
            if (price && price > 0) {
              returnPrice = price;
            }
          });
        }
      }
      return returnPrice;
    },
    calculateSelectedRow(options) {
      if (options.name === "totalCountForFooter") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        } else if (options.summaryProcess === "calculate") {
          options.totalValue += options.value.inventory;
        }
      } else if (options.name === "totalIncomePriceForFooter") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        } else if (options.summaryProcess === "calculate") {
          options.totalValue += this.totalIncomePriceForRow(options.value);
        }
      } else if (options.name === "totalWholePriceForFooter") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        } else if (options.summaryProcess === "calculate") {
          options.totalValue += this.totalWholePriceForRow(options.value);
        }
      } else if (options.name === "totalRetailPriceForFooter") {
        if (options.summaryProcess === "start") {
          options.totalValue = 0;
        } else if (options.summaryProcess === "calculate") {
          options.totalValue += this.totalRetailPriceForRow(options.value);
        }
      }
    },
    refundPrice(row) {
      return this.$options.filters.currency(row.refundsPriceAfterUzsSum, {
        symbol: "",
        fractionCount: 2
      });
    },
    salesPrice(row) {
      return this.$options.filters.currency(row.salesPriceAfterUzsSum, {
        symbol: "",
        fractionCount: 2
      });
    },
    spisatPrice(row) {
      if (row.saleType === "RETAIL") {
        return this.$options.filters.currency(row.whWriteOffRetailPriceSum, {
          symbol: "",
          fractionCount: 2
        });
      } else {
        return this.$options.filters.currency(row.whWriteOffWholePriceSum, {
          symbol: "",
          fractionCount: 2
        });
      }
    },
    firstPrice(row) {
      if (row.saleType === "RETAIL") {
        return this.$options.filters.currency(row.firstRetailPriceSum, {
          symbol: "",
          fractionCount: 2
        });
      } else {
        return this.$options.filters.currency(row.firstWholePriceSum, {
          symbol: "",
          fractionCount: 2
        });
      }
    },
    transferPrice(row) {
      if (row.saleType === "RETAIL") {
        return this.$options.filters.currency(row.whTransferRetailPriceSum, {
          symbol: "",
          fractionCount: 2
        });
      } else {
        return this.$options.filters.currency(row.whTransferWholePriceSum, {
          symbol: "",
          fractionCount: 2
        });
      }
    },
    totalIncomePriceForRow(row) {
      return this.incomePriceForRow(row) * row.inventory;
    },
    totalWholePriceForRow(row) {
      return this.wholePriceForRow(row) * row.inventory;
    },
    totalRetailPriceForRow(row) {
      return this.retailPriceForRow(row) * row.inventory;
    },
    lastPrice(row) {
      if (row.saleType === "RETAIL") {
        return this.$options.filters.currency(row.lastPriceSum, {
          symbol: "",
          fractionCount: 2
        });
      } else {
        return this.$options.filters.currency(row.lastWholePriceSum, {
          symbol: "",
          fractionCount: 2
        });
      }
    },
    onContentReady(e) {
      e.component.option("loadPanel.enabled", false);
    },
    customizeColumns(columns) {
      columns[0].width = 70;
    }
  },
  computed: {
    ...mapGetters("departments", ["myDepartments"]),
    ...mapState(["userDepCurrencyName"]),
    ...mapState("warehouse", ["itemsForWhGrid", "loading"]),
	...mapState(["isAdmin"]),
	isShop() {
		return TokenService.getDepartmentType() === 'SHOP';
	},
    depNames() {
      let str = "";
      if (this.selectedDeps) {
        if (this.selectedDeps.length > 0) {
          this.selectedDeps.forEach(dep => {
            str += dep.name ? dep.name + ", " : " ";
          });
        }
      }
      return str;
    },
    heightAuto() {
      return window.outerHeight / 1.4 + "px";
    }
  },
  watch: {
    "filter.departmentId": {
      handler(newValue) {
        if (newValue) {
          this.depCurrencyCode = newValue.currencyCode;
        }
      }
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style >
.id-class {
  width: 50px !important;
}
</style>
<style scoped>
.alert {
  padding: 15px;
}

.cls1 {
  mso-number-format: "mso-number-format:\@;";
}

.spinner-wrapper {
  position: absolute;
  background: rgba(32, 28, 32, 0.49);
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  padding-top: 35px;
  z-index: 5;
}

.loaderImg {
  position: absolute;
  left: 44%;
  top: 44%;
  z-index: 1;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #0092d3;
  border-bottom: 6px solid #0092d3;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 1.6s linear infinite;
  animation: spin 1.6s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loader {
  position: absolute;
  left: 44%;
  top: 40%;
  z-index: 1;
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  border-top: 2px solid #0092d3;
  border-bottom: 2px solid #0092d3;
  width: 50px;
  height: 50px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}
.card-header {
  padding-bottom: 0px !important;
}
.card-body {
  padding-top: 0 !important;
}

#gridContainer {
  font-size: 10.5px !important;
}
</style>
